/**
 * SEO the store controls (ADR-095): its settings, the fill-in patterns that
 * write a title or description an item does not have, and the SEO fields
 * every page type carries.
 */
/** What the fill-in patterns may name, per page type. */
export const SEO_PATTERN_TOKENS = {
    product: ['name', 'store', 'category', 'brand', 'price'],
    category: ['name', 'store', 'count'],
    brand: ['name', 'store', 'count'],
};
/** Crawlers that collect pages for AI training — not the ones that answer searches. */
export const AI_TRAINING_CRAWLERS = [
    'GPTBot',
    'Google-Extended',
    'CCBot',
    'ClaudeBot',
    'anthropic-ai',
    'Applebot-Extended',
    'Bytespider',
    'meta-externalagent',
];
/** Paths no robots setting may open: what is the shopper's own. */
export const PRIVATE_PATHS = ['/api/', '/cart', '/checkout', '/account', '/orders/view'];
/** Lengths search results show before cutting. */
export const SEO_LENGTHS = { title: { min: 30, max: 60 }, description: { min: 70, max: 160 } };
/**
 * A pattern with its tokens filled. A token with no value goes, and so do the
 * separators it would leave hanging — `{name} | {brand}` without a brand is
 * just the name.
 */
export function fillPattern(pattern, values) {
    /** Marks a token with no value until its separators are dropped: a private-use character no text holds. */
    const EMPTY = '\uE000';
    const filled = pattern.replace(/\{(\w+)\}/g, (_, token) => values[token]?.trim() || EMPTY);
    // A separator is a bar or a dot, or a dash with space either side — never the hyphen inside "full-grain".
    const pieces = filled.split(/(\s+[-–—|·•]\s+|\s*[|·•]\s*)/);
    const kept = [];
    for (let index = 0; index < pieces.length; index += 2) {
        const text = (pieces[index] ?? '').split(EMPTY).join('').replace(/\s+/g, ' ').trim();
        if (!text)
            continue;
        if (kept.length > 0)
            kept.push(pieces[index - 1] ?? ' ');
        kept.push(text);
    }
    return kept
        .join('')
        .replace(/\s+([,:;])/g, '$1')
        .replace(/^[\s,:;|·•–—-]+|[\s,:;|·•–—-]+$/g, '')
        .trim();
}
/** A page's title framed by the store's pattern; without one, `{title} · {store}`. */
export function framedTitle(template, title, store) {
    if (!title)
        return store;
    if (!store)
        return title;
    return fillPattern(template.trim() || '{title} · {store}', { title, store }) || title;
}
/** What SEO health counts across the catalogue (ADR-095). */
export const SEO_ISSUES = [
    'product-no-description',
    'product-thin-description',
    'product-no-alt',
    'product-duplicate-title',
    'product-hidden',
    'category-no-description',
    'category-hidden',
    'brand-no-description',
];
//# sourceMappingURL=seo.js.map